exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.not-allowed[data-v-7f950a5e] {\n  cursor: not-allowed !important;\n  color: #cdd9e4 !important;\n}\n.fade-enter-active[data-v-7f950a5e],\n.fade-leave-active[data-v-7f950a5e] {\n  transition: opacity 0.5s ease, transform 0.5s ease;\n}\n.fade-enter[data-v-7f950a5e],\n.fade-leave-to[data-v-7f950a5e] {\n  opacity: 0;\n  transform: translateY(20px);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-7f950a5e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reservations/NewReservation/Resume/Details.vue
// module id = 2876
// module chunks = 0